<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light main-color">
      <div class="mr-4 text-light h2">{{this.config.projectName}}</div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'ControlHeader',
  methods: {
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ControlHeader.vue